import { Route, Routes } from "react-router-dom";
import OfflineAccessV3 from "../../pages/V3/OfflineAccessV3/OfflineAccessV3";
import { RequireAuth } from "../../utils/auth/auth";

export default function OfflineAccessV3Router() {
  return (
    <Routes>
      <Route
        path=""
        element={
          <RequireAuth>
            <OfflineAccessV3 />
          </RequireAuth>
        }
      />
    </Routes>
  );
}
